import { render, staticRenderFns } from "./ShowInfo.vue?vue&type=template&id=04963d52&scoped=true"
import script from "./ShowInfo.vue?vue&type=script&lang=js"
export * from "./ShowInfo.vue?vue&type=script&lang=js"
import style0 from "./ShowInfo.vue?vue&type=style&index=0&id=04963d52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04963d52",
  null
  
)

export default component.exports